export const features = {
  title: "Feature Requests",
  subtitle:
    "Contribute to the Araria ecosystem and send your feature request, or vote on existing features.",
  subtitle2: "Your opinion matters!",
  voteCount: "Votes",
  approve: "Approve",
  edit: "Edit",
  create: "Create",
  votes: "Votes",
  unvote: "Unvote",
  vote: "Vote",
  filter: "Filter by status",
  showMore: "Show more",
  showLess: "Show less",
  statusFlow: "Status Flow",
  statusFlowDescription:
    "Features follow this workflow from submission to completion.",
  status: {
    ALL: "All Features",
    PENDING: "Pending",
    PENDING_DESC: "Waiting for administrative review",
    APPROVED: "Approved",
    APPROVED_DESC: "Approved by administrative, open to user votes",
    REJECTED: "Rejected",
    REJECTED_DESC:
      "Rejected by administrative, not open to votes, but we can decide to reopen for votes in the future",
    PLANNED: "Planned",
    PLANNED_DESC: "Planned for a future version, but not in development",
    IN_PROGRESS: "In Progress",
    IN_PROGRESS_DESC: "In development",
    PAUSED: "Paused",
    PAUSED_DESC: "Temporarily paused, but not discarded",
    COMPLETED: "Completed",
    COMPLETED_DESC: "Completed and available to all users",
    DECLINED: "Declined",
    DECLINED_DESC: "Decided not to include this feature",
  },
  modal: {
    title: "Create feature request",
    titleEdit: "Edit feature request",
    titleLabel: "Title",
    titlePlaceholder: "Enter the feature title",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Enter the feature description",
    statusLabel: "Status",
    isPublished: "Make public",
    submit: "Submit",
    update: "Update",
    note: "This feature will go through the administrative process, if approved, it will be visible to all users who can vote on it.",
  },
  error: {
    voting: "Error submitting vote.",
    loading: "Error loading features.",
    creating: "Error creating feature request.",
    updating: "Error updating feature request.",
  },
  success: {
    created: "Feature request created successfully.",
    updated: "Feature request updated successfully.",
  },
};
